import React from "react";
import useReveal from "../hooks/useReveal";

export default function SectionHead({ kicker, title, children }) {
  const [ref, visible] = useReveal();
  return (
    <div ref={ref} className={`section__head reveal ${visible ? "is-visible" : ""}`}>
      <span className="section__kicker">{kicker}</span>
      <h2>{title}</h2>
      {children && <p>{children}</p>}
    </div>
  );
}
